import { useState, MouseEvent } from "react";
// import { useLocation } from "react-router-dom";
import MoreVert from "@material-ui/icons/MoreVert";
import Edit from "@material-ui/icons/Edit";
// import Info from "@material-ui/icons/Info";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import { Link } from "@material-ui/core";
import { useTableActionStyles } from "./styles";
import { AttendanceLocalGuiche } from "../../../../../../../../../@types/attendance-local-guiche";
import GuicheFormUpdate from "../../../form/update";
import GuicheDelete from "../../../delete";

type TableActionsProps = {
  guiche: AttendanceLocalGuiche;
}

export default function GuicheTableActions({ guiche }: TableActionsProps) {
  // const { pathname } = useLocation();
  const { classes } = useTableActionStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        {/* <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          href={`${pathname}/guiche/${guiche.id}`}
        >
          <Info htmlColor="#706E7A" />
          Informações
        </MenuItem> */}
        <GuicheFormUpdate
          guiche={guiche}
          slug={guiche.unidade}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Edit htmlColor="#706E7A" />
              Editar
            </MenuItem>
          }
        />
        <GuicheDelete
          guiche={guiche}
          buttonTrigger={
            <MenuItem
              onClick={handleClose}
              className={classes.menuItem}
            >
              <Delete htmlColor="#706E7A" />
              Excluir
            </MenuItem>
          }
        />
      </Menu>
    </>
  );
}
